import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, dailyData, lineupData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab, KScrollspy, utils } from './common/k-tools/k-tools.js';
import productColorSwitch from './common/colorChips.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';
import './jquery.rwdImageMaps.min.js';

let viewWidth;
const swiperHandler = {};
swiperHandler.ta = () => {
  let taSwiper;
  const taSwiperWrapper = $('.ta__swiper .swiper-wrapper');
  const taSwiperSlide = $('.ta__swiper .swiper-slide');
  const taSwiperInit = () => {
    taSwiper = new Swiper('.ta__swiper', {
      speed: 500,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: '.ta__swiper .swiper-button-next',
        prevEl: '.ta__swiper .swiper-button-prev',
      },
    });
  };
  const checkScreenWidth = () => {
    if (viewWidth !== window.innerWidth) {
      viewWidth = window.innerWidth;
      if (viewWidth < 1000) {
        taSwiperInit();
      } else {
        taSwiper?.destroy(true, true);
        taSwiper = null;
        taSwiperWrapper.attr('style', '');
        taSwiperSlide.attr('style', '');
      }
    }
  };
  checkScreenWidth();
  $(window).on('resize', utils.debounce(checkScreenWidth));
};
swiperHandler.lineup = () => {
  const lineupSwiper = new Swiper('.lineup__swiper', {
    slidesPerView: 2,
    spaceBetween: 13,
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    navigation: {
      nextEl: '.lineup .swiper-button-next',
      prevEl: '.lineup .swiper-button-prev',
    },
    breakpoints: {
      1000: {
        slidesPerView: 6,
        spaceBetween: 24,
      },
      800: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
      700: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      600: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
};
swiperHandler.all = () => {
  swiperHandler.ta();
  swiperHandler.lineup();
};

const productTypeSwitch = () => {
  const clickHandler = e => {
    const $this = $(e.currentTarget);
    const productCard = $this.parents('.product__card');
    const img = productCard.find('img');
    const title = productCard.find('.product__title');
    const description = productCard.find('.product__decs');
    const price = productCard.find('.product__price .number');
    const url = productCard.find('> a');
    const data = JSON.parse($this.attr('data'));
    $('.product__type li').removeClass('active');
    $this.addClass('active');
    img.attr('data-src', `./assets/img/products/${data.img.white_bg}`);
    img.attr('src', `./assets/img/products/${data.img.white_bg}`);
    title.text(data.name);
    description.text(data.description);
    price.text(data.price);
    url.attr('href', `https://api.91app.com/es/Redirect/41566/${data.number}`);
  };

  $('.product__type').on('click', 'li', clickHandler);
};

const imgMapRWD = () => {
  $(document).ready(function (e) {
    $('img[usemap]').rwdImageMaps();
  });
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });

  swiperHandler.all();
  productTypeSwitch();
  imgMapRWD();
  productColorSwitch();
  gsapAnimation();
};

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const dailyDataRef = ref(dailyData);
    const lineupDataRef = ref(lineupData);
    const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      dailyDataRef,
      lineupDataRef,
      reportDataRef,
    };
  },
}).mount('#main');
